import { useState } from 'react';

import { Input } from '@gds/Input/Input';
import { useAtom } from 'jotai';

import { finCalcDataFieldValueAtom } from '../../Atoms/FinCalcDataFieldValue.atom';
import { BaseField } from '../../Entities/FinCalcFields.entity';
import { useSetValidity } from '../../Hooks/useSetValidity';

import { inputMask } from './masks';

export const InputElement = ({
  id,
  inputType,
  isValid,
  errorMessage,
  leftIcon,
  rightIcon,
  autoComplete = 'off',
  mask,
  readOnly = false,
}: BaseField) => {
  const [value, setValue] = useAtom(finCalcDataFieldValueAtom(id));
  const [hasTouched, setHasTouched] = useState(false);
  const $ref = useSetValidity({ hasTouched, isValid, errorMessage });

  const handleBlur = () => {
    setHasTouched(true);
  };

  const handleChange = (value: string) => {
    if (!readOnly) {
      const num = typeof value === 'number' ? String(value) : value;

      const plainNumber = Number(num.replace(/[^\d]/g, ''));

      setValue(plainNumber);
    }
  };

  const maskedValue = mask ? inputMask(mask, value, 'uk') : value;

  return (
    <Input
      dataTestId={id}
      id={id}
      ref={$ref}
      type={inputType}
      autoComplete={autoComplete}
      error={hasTouched && !isValid && errorMessage}
      fullWidth
      onChange={e => handleChange(e.target.value)}
      value={maskedValue}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      onBlur={handleBlur}
      readOnly={readOnly}
      disabled={readOnly}
    />
  );
};
